const  ViewState = {
    noteVisible: false
}
export default ViewState;
